import { REFERENCE_DOCUMENTS_ROW_LABEL } from './constants';
import { ReferenceDocumentsHeader, ReferenceDocumentsRowConfig, ReferenceDocumentsRowModel } from './types';

const getHeaderName = (header: ReferenceDocumentsHeader) => header.name;

/**
 * What the "Reference Documents" row decides, shared by the two surfaces that draw it: the statement
 * table (Audited and Provisional, a real `<table>`) and the Financial Summary (a CSS grid). Each keeps
 * its own markup; neither re-derives the gate, the label or a cell's props.
 *
 * Returns null for an untagged response (no `sourceFilesStatus`): no row at all, rather than a label
 * over empty cells. Conditions that belong to one surface alone (the table's opt-in prop, the Summary's
 * tab / loading / empty checks) stay with that surface.
 */
export const getReferenceDocumentsRow = <THeader extends ReferenceDocumentsHeader = ReferenceDocumentsHeader>({
    sourceFilesStatus,
    onOpen,
    statement,
    getColumnLabel = getHeaderName,
}: ReferenceDocumentsRowConfig<THeader>): ReferenceDocumentsRowModel<THeader> | null => {
    if (sourceFilesStatus === undefined) return null;

    return {
        label: REFERENCE_DOCUMENTS_ROW_LABEL,
        getTagProps: (header) => ({
            sourceFiles: header.sourceFiles,
            status: sourceFilesStatus,
            statement,
            columnLabel: getColumnLabel(header),
            onOpen,
        }),
    };
};
